import { useState, useEffect } from 'react'
import http from 'http'

import { LuRoute } from 'react-icons/lu'
import { FiUsers } from 'react-icons/fi'

const Groups = () => {
  const [ groupList, setGroupList ] = useState()

  useEffect( () => {
    if ( ! groupList )
      return

    http( {
      method: 'PUT',
      url: '/settings/groups',
      data: groupList
    } )
      .then( ( { data } ) => {
        console.log( { update: data } )
      } )
  }, [ groupList ] )

  useEffect( () => {
    if ( groupList )
      return

    http( {
      method: 'GET',
      url: '/settings/groups'
    } )
      .then( ( { data } ) => {
        setGroupList( groupList => {
          return data
        } )
      } )
  } )

  const handleChangeColor = ( index, e ) => {
    const { value } = e.target

    const list = [ ...groupList ]

    list[ index ].color = value

    setGroupList( list )
  }

  if ( ! groupList )
    return null

  return <div className="scroll one hs gap-2x in-air-2x">
    <div className="vs gap-2x size-3x5">
      <span>
        <FiUsers />
      </span>

      <span>groups</span>
    </div>

    <ul className="list-menu">
      { groupList.map( ( group, index ) => <li
        key={ index }
        className="list-item"
      >
        <span className="icon">
          <LuRoute />
        </span>

        <span className="one text">{ group.name }</span>

        <input
          name={ group.name }
          type="color"
          value={ group.color }
          onChange={ ( e ) => handleChangeColor( index, e ) }
        />
      </li> ) }
    </ul>

  </div>
}

export default Groups
